import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step, automation, fields }) => {
  const data =
    step?.details && Object.keys(step?.details).length !== 0
      ? step.details
      : step.actionHttpRequest;

  return `${data.method} Request to '${data.url}'`;
};

export default function HttpRequestCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
